export const SourceName = {
  Private: 'private',
  Public: 'public',
  Trash: 'trash',
  VisitorsUploads: 'visitorsUploads'
};